<div class="hoca-root container py-3">

  <!-- ÜST BLOK (Öğrenci tarafıyla uyumlu) -->
  <div class="d-flex align-items-center justify-content-between mb-4">
    <div>
      <h4 class="page-title mb-0 text-white">Ders Programı</h4>
      <small class="opacity-75 text-white">Hoş geldiniz, iyi dersler dileriz.</small>
    </div>
    <div class="d-flex gap-2">
      <a href="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/" target="_blank" class="btn btn-action-icon" title="Kullanım Kılavuzu">
        <i class="fa fa-question-circle"></i>
      </a>
      <button class="btn btn-action-icon" (click)="refreshData()">
        <i class="fa fa-sync-alt" [class.fa-spin]="isLoading"></i>
      </button>
    </div>
  </div>

  <!-- GÜN TABLARI (Öğrenci tarafındaki Flutter-style yapı) -->
  <div class="tabs-container mb-4">
    <ul class="nav custom-tabs scroll-tabs">
      <li class="nav-item" *ngFor="let day of weekdays; let i = index">
        <button class="nav-link" [class.active]="selectedTab === i" (click)="selectedTab = i">
          {{ day }}
        </button>
      </li>
    </ul>
  </div>

  <!-- YÜKLENİYOR -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-light" role="status"></div>
  </div>

  <!-- DERS LİSTESİ -->
  <div *ngIf="!isLoading" class="animate-fade-in">
    <div *ngFor="let item of filterByDay(weekdays[selectedTab])" class="modern-lesson-card mb-3">

      <!-- Renkli Durum Şeridi -->
      <div class="status-indicator" [ngClass]="getStatusClass(item)"></div>

      <div class="p-3">
        <div class="row g-0 align-items-center">

          <!-- SOL: DERS BİLGİLERİ -->
          <div class="col-8">
            <div class="d-flex align-items-center gap-2 mb-2">
              <span class="badge-type">{{ item.dersTuru }}</span>
              <div class="time-badge-modern">
                <i class="far fa-clock"></i> {{ formatTimeRange(item.baslangicSaati, item.bitisSaati) }}
              </div>
            </div>

            <h5 class="lesson-name mb-2 text-white">{{ item.dersAdi }}</h5>

            <div class="info-row">
              <i class="fa fa-door-open"></i>
              <span>{{ item.derslik || 'Derslik bilgisi yok' }}</span>
            </div>
          </div>

          <!-- SAĞ: AKSİYON BUTONU -->
          <div class="col-4 ps-2 d-flex justify-content-end ">
            <button class="btn btn-main-action w-100"
                    [ngClass]="getButtonClass(item)"
                    (click)="onStartAttendance(item)">
              <i class="bi bi-qr-code-scan mb-1"></i>
              <span>{{ yoklamaText(item) }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- BOŞ DURUM -->
    <div *ngIf="filterByDay(weekdays[selectedTab]).length === 0" class="no-data-card text-center p-5">
      <div class="empty-icon"><i class="fa fa-calendar-check opacity-25"></i></div>
      <h6 class="text-white mt-3">Bugün Dersiniz Bulunmuyor</h6>
      <p class="text-white-50 small">Seçilen gün için tanımlanmış bir ders kaydı mevcut değil.</p>
    </div>
  </div>
</div>
